import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileModel } from 'src/app/models/file.model';
import { RawFileModel } from 'src/app/models/raw-file-model';
import { rawToDataBase64Url } from 'src/app/utils/file.utils';

interface PreviewFileModel {
  fileName: string;
  fileUrl: string;
  fileExtension: string;
}

@Component({
  selector: 'app-file-viewer-modal',
  standalone: false,
  templateUrl: './file-viewer-modal.component.html',
  styleUrl: './file-viewer-modal.component.scss'
})
export class FileViewerModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();

  @Input() width: string | number = '1000px';
  @Input() height: string | number = '90%';

  @Input() file!: FileModel | RawFileModel;

  previewFile?: PreviewFileModel;

  ngOnChanges(): void {
    if (this.file) {
      this.previewFile = this.toPreviewFile(this.file);
    }
  }

  private toPreviewFile(file: FileModel | RawFileModel): PreviewFileModel {
    if ('fileUrl' in file) {
      return {
        fileName: file.fileName,
        fileUrl: file.fileUrl,
        fileExtension: file.fileExtension.toLowerCase()
      };
    }

    const extension = '.' + file.name.split('.').pop()?.toLowerCase();
    const url = rawToDataBase64Url(file);

    return {
      fileName: file.name,
      fileUrl: url,
      fileExtension: extension
    };
  }

  onClose(): void {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
